// extracted by mini-css-extract-plugin
export default {"root":"AddingFormErrors_root__slnr6","item":"AddingFormErrors_item__NfCtt","placeHolderShimmer":"AddingFormErrors_placeHolderShimmer__OoLcE"};